import React from "react";
import "react-activity/dist/library.css";
import { Root, Img } from "./style"
import logo from "../../assets/logo.png";
import ButtonLog from "../buttonCadastro";
import BarraProgresso3 from "../barraProgresso/cpageThreeBar";
import { Link } from "react-router-dom";


const RootCadastro3: React.FC = () => {
    return ( 
    <>
        <Root>
            <div>
                <Link to="/">
                    <Img src={logo} alt="logo" />
                </Link>
            </div>
            <div>
                <ButtonLog />
            </div>
        </Root>
        <BarraProgresso3 />
    </>
    );
};

export default RootCadastro3;